var TestHttpService = /** @class */ (function () {
    function TestHttpService(config) {
        this.response = undefined;
        this.error = undefined;
        Object.assign(this, config);
    }
    TestHttpService.prototype.getAsync = function (call, options) {
        return this.resolveTestCall();
    };
    TestHttpService.prototype.postAsync = function (call, options) {
        return this.resolveTestCall();
    };
    TestHttpService.prototype.putAsync = function (call, options) {
        return this.resolveTestCall();
    };
    TestHttpService.prototype.patchAsync = function (call, options) {
        return this.resolveTestCall();
    };
    TestHttpService.prototype.deleteAsync = function (call, options) {
        return this.resolveTestCall();
    };
    TestHttpService.prototype.createCancelToken = function () {
        return {
            cancel: function () { },
            token: undefined
        };
    };
    TestHttpService.prototype.resolveTestCall = function () {
        var _this = this;
        var promise = new Promise(function (resolve, reject) {
            if (_this.response) {
                resolve(_this.response);
            }
            if (_this.error) {
                reject(_this.error);
            }
            throw Error("Missing test data");
        });
        return promise;
    };
    return TestHttpService;
}());
export { TestHttpService };
//# sourceMappingURL=test-http.service.js.map